import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from 'swiper'; 
Swiper.use([Thumbs, Navigation, Pagination, Autoplay]);

export default class WholesalersSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.slider = this.root.querySelector('[data-swiper-slider-swiper]');
        this.swiper = null;
        this.prevProgress = 0;

        return true;
    }

    init() {
        this.initSwiper();
    }

    initSwiper() {
        if (!this.slider) return;

        this.swiper = new Swiper(this.slider, {
            slidesPerView: 'auto',
            loop: true,
            spaceBetween: 30,
            autoplay: {
                delay: 2000,
            },
            breakpoints: {
                768: {
                    spaceBetween: 140
                }
            }
        });
    }
}